import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CurrencyFormatterPipe } from "src/app/pipes/currency-formatter/currency-formatter.pipe";
import { DateFormatPipe } from "src/app/pipes/date-format/date-format.pipe";
import { ConfigService } from "src/app/services/config/config.service";
@Component({
  selector: "app-limits-table-row",
  templateUrl: "./limits-table-row.component.html",
  styleUrls: ["./limits-table-row.component.scss"],
})
export class LimitsTableRowComponent {
  @Input() title: any;
  @Input() globalLimit: any;
  @Input() currency: any;
  @Input() set limitData(val: any) {
    this._limitData = val;
    if (this.limitData) this.updateLimits(this.limitData);
  }
  @Input() formInputName: any;
  @Input() limitDataForm: any;
  @Input() limitError: boolean;

  @Output() deleteEvent = new EventEmitter();
  @Output() enterPressedEvent = new EventEmitter();
  @Output() limitChangedEvent = new EventEmitter();

  public showDelete: boolean = false;
  public showNewLimit: boolean = true;
  public showNewLimitInput: boolean = true;
  private _limitData: any;

  public get limitData(): any {
    return this._limitData;
  }

  constructor(
    public currencyFormatterPipe: CurrencyFormatterPipe,
    public config: ConfigService,
    public dateFormatPipe: DateFormatPipe
  ) {}

  preventDefault(event) {
    event.preventDefault();
  }

  formatNumberWithCommas(number) {
    return this.currencyFormatterPipe.transform(number, this.currency);
  }

  updateLimits(limitData: any) {
    if (limitData) {
      this.showDelete =
        limitData.currentLimit != null || limitData.currentLimit != "";

      if (limitData.newLimit && limitData.endPeriod) {
        this.showDelete = false;
        //this.showNewLimitInput = false;
      } else if (!limitData.newLimit && limitData.deleteFlag == "1") {
        this.showDelete = false;
        //this.showNewLimit = false;
      }
    }
  }
}
